import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Hero from '../common/hero';
import Followers from './followers';
import InvestorTypes from './investor-types';
import ContributorLeaderboard from './contributor-leaderboard';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  ${props => props.theme.isXXLarge && `
    width: 1200px;
  `};
  ${props => props.theme.isXLarge && `
    width: 953px;
  `};
  ${props => props.theme.isLarge && `
    width: 85%;
  `};
  ${props => props.theme.isMobile && `
    width: 100%;
  `};

  & > *:not(:first-child) {
    margin-top: 80px;
  }
`;

const contributorsToMaxDaysAgo = contributors => {
  const endOfDay = moment().endOf('day');
  const createdDays = contributors.map(c => endOfDay.diff(c.createdAt, 'days'));
  return Math.max.apply(null, createdDays);
};

export default function DesktopView({
  id,
  cachedAnalyticsDataUrls,
  contributors,
  investorTypes,
  contributorCount,
}) {
  const actualDaysAgo = contributorsToMaxDaysAgo(contributors);
  const props = {
    id, cachedAnalyticsDataUrls, contributors, actualDaysAgo, investorTypes, contributorCount,
  };

  return (
    <>
      <Hero type="audience" />
      <Container>
        <Followers {...props} />
        <InvestorTypes {...props} />
        <ContributorLeaderboard {...props} />
      </Container>
    </>
  );
}

DesktopView.propTypes = {
  id: PropTypes.number.isRequired,
  cachedAnalyticsDataUrls: PropTypes.shape({
    followersDataUrl: PropTypes.string,
    contributorRankingDataUrl: PropTypes.string,
    investorTypesDataUrl: PropTypes.string,
  }).isRequired,
  contributors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    profilePictureUrl: PropTypes.string,
    createdAt: PropTypes.string,
  })).isRequired,
  investorTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  contributorCount: PropTypes.number.isRequired,
};
